import React, { forwardRef } from 'react';
import {
    Dialog,
    Box,
    IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PayIn from '../PayIn/PayIn';
import {
    getDialogPaperStyle,
    getHeaderBoxStyle,
    getHeaderTitleStyle,
    getHeaderSubtitleStyle,
    getCloseButtonStyle,
    getContentBoxStyle
} from './AddFundsModalCss';

/**
 * Reusable Add Funds Modal.
 * Wraps the PayIn component in a Dialog with a custom styled header.
 * Uses forwardRef to expose the PayIn component's methods (like handleAddFunds) to the parent.
 */
const AddFundsModal = forwardRef(({ open, onClose, setIsPaymentGuidelinesModalOpen }, ref) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            PaperProps={{
                sx: getDialogPaperStyle()
            }}
        >
            {/* Custom Modal Header */}
            <Box sx={getHeaderBoxStyle}>
                <Box>
                    <Box sx={getHeaderTitleStyle()}>Add Funds</Box>
                    <Box sx={getHeaderSubtitleStyle()}>Add money to your trading account</Box>
                </Box>
                <IconButton
                    onClick={onClose}
                    sx={getCloseButtonStyle()}
                >
                    <CloseIcon />
                </IconButton>
            </Box>
            {/* Scrollable PayIn content */}
            <Box sx={getContentBoxStyle()}>
                <PayIn
                    ref={ref}
                    onClose={onClose}
                    isModal={true}
                    setIsPaymentGuidelinesModalOpen={setIsPaymentGuidelinesModalOpen}
                />
            </Box>
        </Dialog>
    );
});

export default AddFundsModal;
